import React from 'react';
import '../css/global.css';
import '../css/Hero.css';
import heroImage from '../images/boyd-hero-image.jpg';
import heroCloud1 from '../images/hero-cloud-1.webp'
import heroCloud2 from '../images/hero-cloud-2.webp'

const Hero: React.FC = () => {
    return (
        <section className="hero">
            <div className="container">
            <div className="image-blocks">
                <img src={heroCloud1} className="hero-cloud-1 clouds img-fluid" alt="Cloud1" />
                <img src={heroImage} className="main img-fluid" alt="HeroImage" />
                <img src={heroCloud2} className="hero-cloud-2 clouds img-fluid" alt="Cloud2" />
            </div>
                <div className="hero-text">
                    <h1>Stephanie Jeter</h1>
                    <p>Frontend Developer building modern web applications with React, Django, and Next.js.</p>
                </div>
                 <div className="btn-group">
                    <a href="#myWork" className="btn btn-primary primary-button-green">View My Work</a>
                    <a href="mailto:steph@stephjeter.com" className="btn primary-button-transparent">Get in Touch <i className="fa-solid fa-arrow-right-long"></i></a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
